import { render, staticRenderFns } from "./RenewalInputField.vue?vue&type=template&id=031fb94a&scoped=true"
import script from "./RenewalInputField.vue?vue&type=script&lang=ts"
export * from "./RenewalInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031fb94a",
  null
  
)

export default component.exports